<ion-content>
  <div class="imgDiv">
    <img src="assets/imgs/logo.svg" alt="Flamr">
  </div>
  <div class="container">
    <ion-avatar *ngIf="otherUserData?.firstPic !== ''">
      <img [alt]="otherUserData?.firstName" [src]="otherUserData?.firstPic" />
    </ion-avatar>
    <div class="text-invited">
      {{ otherUserData?.firstName }} {{ 'isinvitingYouToJoin' | translate }}
    </div>
    <div class="text-explanation">
      {{ 'invitingDescription' | translate }}
    </div>
    <div class="featureButtons">
      <ion-button expand="full" (click)="loginWithFB()" shape="round" class="facebookSignin">
        <ion-icon name="logo-facebook" slot="start"></ion-icon>
        {{ 'loginWithFB' | translate }}
      </ion-button>
      <ion-button expand="full" (click)="googleSignIn()" shape="round">
        <ion-icon name="logo-google" slot="start"></ion-icon>
        {{ 'signInWithGoogle' | translate }}
      </ion-button>
      <ion-button expand="full" (click)="openDefaultLogin()" class="defaultLogin" shape="round">
        {{ 'createAnAccount' | translate }}
      </ion-button>
    </div>
  </div>
</ion-content>